import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64daf560"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-image" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "base-image__caption padded" }

import { computed } from 'vue';

export type Props = {
  url: string,
  alt: string,
  description: string,
  username: string,
  userUrl: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseImage',
  props: {
    url: {},
    alt: {},
    description: {},
    username: {},
    userUrl: {}
  },
  setup(__props: any) {

const props = __props;



const title = computed(() => {
  if (props.description.length < props.alt.length) {
    return props.description || props.alt;
  }

  return props.alt || props.description;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _createElementVNode("div", {
      class: "base-image__container",
      role: "img",
      "aria-label": _ctx.alt,
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.url})` })
    }, null, 12, _hoisted_2),
    _createElementVNode("figcaption", _hoisted_3, _toDisplayString(title.value), 1)
  ]))
}
}

})